<template>
  <div class="order-menu-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('home.home') }}</strong>
            </div>
            <b-col cols="12" class="text-center">
              <b-row>
                <div class="table-responsive">
                  <table class="table table-striped table-hover table-sm table-bordered">
                    <thead>
                    <tr>
                      <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)" v-show="checkShowByConfig(item.name)" :class="item.sort?'pointer':''">
                        <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                        <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                        <span v-if="item.label != null">{{$t('order.'+item.label)}}</span>
                        <span v-if="item.label == null">{{$t('order.'+item.name)}}</span>
                      </th>
                      <th scope="col" style="min-width: 240px">{{$t('common.action')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="dataTable.items.length == 0">
                      <td class="text-center" :colspan="dataTable.fields.length + 1">
                        {{$t('message.no_data')}}
                      </td>
                    </tr>
                    <tr v-for="item in dataTable.items" :key="item.id">
                      <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id" v-show="checkShowByConfig(field.name)">
                        <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                        <span v-else>{{item[field.name]}}</span>
                      </td>
                      <td scope="row">
                        <div class="row">
                          <div class="col-md-6">
                            <b-button variant="primary" class="btn-action-view border-radius-4px bg-main" @click="showOrderDetail(item.uuid)">
                              <i class="fa fa-eye" aria-hidden="true"></i> {{$t('order.summary_view')}}</b-button>
                          </div>
                          <div class="col-md-6">
                            <b-button variant="primary" class="btn-edit-cancel border-radius-4px bg-main" v-on:click="itemDetail(item.uuid)">
                              <i class="fa fa-edit"></i> {{$t('common.edit')}}
                            </b-button>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6" v-show="order.config.proceed">
                            <b-dropdown variant="primary" style="margin-left:-23px;" right text="Action">
                              <b-dropdown-item :key="item.id+10" @click="processOrder(item,10)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process</b-dropdown-item>
                              <b-dropdown-item :key="item.id+11" @click="processOrder(item,11)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 30 mins</b-dropdown-item>
                              <b-dropdown-item :key="item.id+12" @click="processOrder(item,12)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 45 mins</b-dropdown-item>
                              <b-dropdown-item :key="item.id+13" @click="processOrder(item,13)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 45 mins No Gua</b-dropdown-item>
                              <b-dropdown-item :key="item.id+14" @click="processOrder(item,14)"><i class="fa fa-spinner" aria-hidden="true" style="color:gray"></i>Process 60 mins</b-dropdown-item>
                              <b-dropdown-item :key="item.id+7" @click="processOrder(item,7)"><i class="fa fa-check-square-o" aria-hidden="true" style="color:gray"></i>Completed</b-dropdown-item>
                              <b-dropdown-item :key="item.id+1" @click="print(item.uuid)"><i class="fa fa-print" aria-hidden="true" style="color:gray"></i>Print</b-dropdown-item>
                              <b-dropdown-item :key="item.id+8" @click="processOrder(item,8)"><i class="fa fa-times" aria-hidden="true" style="color:gray"></i>Cancel</b-dropdown-item>
                              <b-dropdown-item :key="item.id+2" @click="deliveryReceipt(item)"><i class="fa fa-ship" aria-hidden="true" style="color:gray"></i>Delivery Receipt</b-dropdown-item>
                              <b-dropdown-item :key="item.id+3" @click="sendEmail(item)"><i class="fa fa-envelope-o" aria-hidden="true" style="color:gray"></i>Email</b-dropdown-item>
                            </b-dropdown>
                          </div>

                          <div class="col-md-6" v-show="0 && order.config.cancel && _.indexOf([7, 8, 9], item.status) < 0">
                            <b-button variant="danger" class="btn-edit-cancel border-radius-4px" @click="processOrder(item,8)">
                              <i class="fa fa-window-close"></i> {{$t('common.cancel')}}
                            </b-button>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6" v-show="0 && order.config.resend">
                            <b-button variant="primary" class="btn-action-resend border-radius-4px bg-main" @click="resendToEios(item.uuid)">
                              <i class="fa fa-retweet" aria-hidden="true"></i> {{$t('order-phil.resend_to_eios')}}</b-button>
                          </div>

                          <div class="col-md-6" v-show="0 && checkShowByConfig('create_manually')">
                            <b-button variant="primary" class="btn-edit-manually border-radius-4px bg-main" v-on:click="createManually(item.uuid)">
                              <i class="fa fa-hand-rock-o"></i> {{$t('order-phil.create_manually')}}
                            </b-button>
                          </div>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </b-row>
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                </b-col>
              </b-row>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div id="modal_order_detail" class="row" v-if="orderDetail">
      <b-modal class="view-modal-lg" size="huge" v-model="review_model" @ok="review_model = false" :hide-footer="true" :hide-header="true">
        <table class="table table-borderless">
          <thead>
          <tr>
            <th scope="col">{{$t('order.order_number')}}</th>
            <th scope="col">{{$t('order.delivery_address')}}</th>
            <th scope="col" v-show="checkShowByConfig('payment_method')">{{$t('order.payment_method')}}</th>
            <th scope="col" v-show="checkShowByConfig('payment_status')">{{$t('order.payment_status')}}</th>
            <th scope="col" v-show="checkShowByConfig('processing')">{{$t('order.processing')}}</th>
            <th scope="col" v-show="checkShowByConfig('customer_detail')">{{$t('order.customer_detail')}}</th>
            <th scope="col">{{$t('order.order_detail')}}</th>
            <th>
              <div class="pull-right" style="margin-top: -48px;margin-right: -1px;">
                <a href="javascript:void(0)" @click="review_model = false" class="close" style="font-size:35px;">&times;</a>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{orderDetail.order_number}}</td>
            <td><span v-if="orderDetail.order_type == 'D'">{{orderDetail.address}}</span></td>
            <td v-show="checkShowByConfig('payment_method')">{{orderDetail.payment_method}}</td>
            <td v-show="checkShowByConfig('payment_status')"><span v-if="orderDetail.order_status">{{orderDetail.order_status.name}}</span></td>
            <td v-show="checkShowByConfig('processing')"><span v-if="orderDetail.assigned">{{orderDetail.assigned.name}}</span></td>
            <td v-show="checkShowByConfig('customer_detail')">
              <div class='wrap'>
                <div class = "blocks">
                  <i class="fa fa-user"></i>&nbsp; {{orderDetail.name}}
                </div>

                <div class = "blocks">
                  <i class="fa fa-envelope"></i>&nbsp; {{orderDetail.email}}
                </div>

                <div class = "blocks">
                  <i class="fa fa-phone"></i>&nbsp; {{orderDetail.phone}}
                </div>

                <div class = "blocks">
                  <i class="fa fa-home"></i>&nbsp; {{orderDetail.address}}
                </div>
              </div>
            </td>
            <td colspan="2">
              <div class="wrap">
                <div class="blocks">
                  <div v-for="(item,index) in orderDetail.order_items" :key="index+0" class="order-details">
                    <!-- Type = 0 => Single -->
                    <div v-if="item.type == 0">
                      <div v-for="(sub_item, sub_index) in item.items" :key="sub_index+0">
                        <div class="item-row">
                          <div class="item-name">
                            <strong><span v-if="sub_item.quantity > 1">{{sub_item.quantity}} x </span> {{sub_item.name}}</strong>
                          </div>
                          <div class="item-price"><strong>{{ formatPrice(sub_item.total)}} ({{currency.symbol}})</strong></div>
                        </div>
                        <div class="item-row" v-if="sub_item.first.uuid != '' && sub_item.first.second.uuid != ''">
                          <div class="option-name">{{sub_item.first.name}} - {{sub_item.first.second.name}}</div>
                          <div class="item-price">{{sub_item.first.price + sub_item.first.second.price}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-for="topping in sub_item.topping.extra">
                          <div class="topping-name">{{$t('common.add')}} {{topping.name}}</div>
                          <div class="item-price">{{topping.price  * topping.quantity}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-for="topping in sub_item.topping.remove">
                          <div class="topping-name">{{$t('common.remove')}} {{topping.name}}</div>
                          <div class="item-price"></div>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="item.type == 2">
                      <div class="item-row">
                        <div class="item-name">
                          <strong><span v-if="item.quantity > 1">{{item.quantity}} x </span> {{item.name}} </strong>
                        </div>
                        <div class="item-price"><strong>{{formatPrice(item.total)}} ({{currency.symbol}})</strong></div>
                      </div>
                      <div v-for="(sub_item, sub_index) in item.items" :key="sub_index+0">
                        <div class="item-row">
                          <div class="item-name pl-2">
                            {{ (sub_index % 2 == 0) ? $t('orders.left_half') : $t('orders.right_half')}}
                          </div>
                          <div class="item-name pl-3">
                            <strong>{{sub_item.name}}</strong>
                          </div>
                        </div>
                        <div class="item-row" v-if="sub_item.first.uuid != '' && sub_item.first.second.uuid != ''">
                          <div class="option-name">{{sub_item.first.name}} - {{sub_item.first.second.name}}</div>
                          <div class="item-price">{{sub_item.first.price + sub_item.first.second.price}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-for="topping in sub_item.topping.extra">
                          <div class="topping-name">{{$t('common.add')}} {{topping.name}}</div>
                          <div class="item-price">{{topping.price  * topping.quantity}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-for="topping in sub_item.topping.remove">
                          <div class="topping-name">{{$t('common.remove')}} {{topping.name}}</div>
                          <div class="item-price"></div>
                        </div>
                      </div>
                    </div>
                    <!-- Type = 1 => Combo -->
                    <div v-else-if="item.type == 1">
                      <div class="item-row">
                        <div class="item-name">
                          <strong><span v-if="item.quantity > 1">{{item.quantity}} x </span> {{item.name}}</strong>
                        </div>
                        <div class="item-price"><strong>{{formatPrice(item.total)}} ({{currency.symbol}})</strong></div>
                      </div>
                      <div v-for="(sub_item, sub_index) in item.items" :key="sub_index+0">
                        <div class="item-row">
                          <div class="item-name">
                            <span v-if="sub_item.quantity > 1">{{sub_item.quantity}} x </span> {{sub_item.name}}
                          </div>
                          <div class="item-price">{{formatPrice(sub_item.total)}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-if="sub_item.first.uuid != '' && sub_item.first.second.uuid != ''">
                          <div class="option-name">{{sub_item.first.name}} - {{sub_item.first.second.name}}</div>
                          <div class="item-price">{{sub_item.first.price + sub_item.first.second.price}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-for="topping in sub_item.topping.extra">
                          <div class="topping-name">{{$t('common.add')}} {{topping.name}}</div>
                          <div class="item-price">{{topping.price  * topping.quantity}} ({{currency.symbol}})</div>
                        </div>
                        <div class="item-row" v-for="topping in sub_item.topping.remove">
                          <div class="topping-name">{{$t('common.remove')}} {{topping.name}}</div>
                          <div class="item-price"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr v-if="orderDetail.note!=null">

                <div class="blocks" v-if="orderDetail.note!=null">
                  <a class="btn btn-danger btn-xs btn-note">NOTE</a>
                </div>
                <div class="blocks" v-if="orderDetail.note!=null">
                  <li class="li-note">{{orderDetail.note}}</li>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </b-modal>
    </div>

    <div id="modal_print_order" class="row" v-if="orderDetail">
      <b-modal class="view-modal-lg" title="Review order detail before print" size="huge-extra" v-model="print_model" @ok="print_model = false" :hide-footer="true">
        <div id="export_to_pdf"></div>
      </b-modal>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import pdfobj from 'pdfobject'
const CancelToken = axios.CancelToken
let cancel = null
let vm = null
export default {
    name: 'home',
    data: function () {
        return {
            currency: this.$store.getters.config.gms.currency_info,
            order: this.$store.getters.config.gms.order,
            orderDetail:{},
            review_model: false,
            print_model:false,
            type: 'like',
            statuses: [],
            order_types: [],
            date: [],
            filter: {
                options: [],
                selected: null,
                status: '4',
                order_type: '',
                code: '',
                field: null,
                key: null,
            },
            dataTable: {
                items: [],
                fields: [
                    {
                        name: 'order_reference',// sing
                        filter: false,
                        sort: false,
                        render: (data, row) => {
                            if(data==null) return ''
                            return data.name
                        }
                    },
                    {
                        name: 'order_status', //phils,japan
                        label: 'status',
                        filter: false,
                        sort: false,
                        render: (data, row) => {
                            if(data==null) return ''
                            return this.$t('order.order_status_' + data.id)
                        }
                    },
                    {
                        name: 'order_number',//phils,japan,sing
                        filter: true,
                        sort: true,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            return data
                        }
                    },
                    {
                        label: 'customer_detail',// sing
                        name: 'customer_detail',
                        filter: false,
                        sort: false,
                        render: (data, row) => {
                            return row.name + ' <br/> ' + row.email + ' <br/> ' + row.phone
                        }
                    },
                    {
                        name: 'name',//phils,japan
                        filter: true,
                        sort: false,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            return data
                        }
                    },
                    {
                        name: 'email',//phils,japan
                        filter: true,
                        sort: false,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            return data
                        }
                    },
                    {
                        name: 'phone',//phils,japan
                        filter: true,
                        sort: false,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            return data
                        }
                    },
                    {
                        name: 'order_type',//phils,japan,sing
                        filter: false,
                        sort: false,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            let type;
                            if (data == 'D') {
                                type = vm.$t('common.delivery')
                            }
                            if (data == 'C') {
                                type = vm.$t('common.takeaway')
                              if (row.referral_code === 'qr') {
                                type = vm.$t('common.takeaway_qr')
                              }
                            }
                            return type
                        }
                    },
                    {
                        name: 'outlet_name',//phils,japan
                        filter: true,
                        sort: false,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            return row.outlet_code + '  ' + data
                        }
                    },
                    {
                        name: 'channel', // phils,japan
                        label: 'sale_channel', // phils,japan
                        filter: false,
                        sort: false,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            return data
                        }
                    },
                    {
                        name: 'payment_method',// sing
                        filter: false,
                        sort: false,
                        render: (data, row) => {
                            if(data==null) return ''
                            return row.payment_method
                        }
                    },
                    {
                        name: 'store_delivery_address',// sing
                        filter: false,
                        sort: false,
                        render: (data, row) => {
                            return row.outlet_address + ', #' + row.address
                        }
                    },
                    {
                        name: 'eios_sending_log',// sing
                        filter: false,
                        sort: false,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            return row.outlet_code + '  ' + data
                        }
                    },
                    {
                        name: 'total',//phils,japan
                        filter: false,
                        sort: false,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            return new Intl.NumberFormat().format(data) + ' ' + this.$t('order.'+row.currency)
                        }
                    },
                    {
                        name: 'created_at',//phils,japan
                        filter: false,
                        sort: true,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            let timezone = row.outlet_timezone
                            return this.convertUTCToTimeZone(data, timezone) ? this.convertUTCToTimeZone(data, timezone).format( this.$store.getters.config.main.date_format ? this.$store.getters.config.main.date_format.toUpperCase() + " HH:mm:ss" : 'DD/MM/YYYY HH:mm:ss') : data
                        }
                    },
                    {
                        name: 'collection_time', // phils,japan
                        filter: false,
                        sort: true,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            let timezone = row.outlet_timezone
                            return this.convertUTCToTimeZone(data, timezone) ? this.convertUTCToTimeZone(data, timezone).format(this.$store.getters.config.main.date_format ? this.$store.getters.config.main.date_format.toUpperCase() + " HH:mm:ss" : 'DD/MM/YYYY HH:mm:ss') : data
                        }
                    },
                    {
                        name: 'assigned',//phils,japan
                        filter: false,
                        sort: true,
                        render: (data, row) => {
                            if (data == null) {
                                return ''
                            }
                            return data.name
                        }
                    }
                ],
                sort: {
                    field: 'updated_at',
                    type: 'desc'
                },
                currentPage: 1,
                total: 0,
                perPage: 10,
                source: null
            },
            item: {}
        }
    },
    methods: {
        /**
         * convert date format then refresh data when date range update
         * @param val
         */
        updateDateRange (val) {
            this.date = val
            this.filter.startAt = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().subtract(7, 'days').format('YYYY-MM-DD')
            this.filter.endAt = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
            this.refreshData()
        },
        checkShowByConfig (key) {
            if (this.order == null) {
                return true
            }
            let config = this._.find(this.order.list, function (o) {
                return o.type === key
            })
            if (config == null) {
                return true
            }
            return config.show
        },
        deliveryReceipt(item){},
        print(uuid){
            vm = this;
            vm.print_model=true
            vm.axios.order.printOrderDetail(uuid,
                function (response) {
                    let blob = new Blob([response.data], { type: 'application/pdf' })
                    let link = document.createElement('a')
                    vm.src=window.URL.createObjectURL(blob)
                    pdfobj.embed(vm.src, "#export_to_pdf")
                })
        },
        sendEmail(item){},
        resendToEios(item){},
        createManually(item){},
        processOrder(item,status){
            vm=this
            vm.axios.order.getOrderDetailForProcessAction(item.uuid,{status : status},
                function (response) {
                    vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
                    let data=response.data.data.item
                    if(data){
                        vm.$set(item,'order_status',data.order_status)
                        vm.$set(item,'assigned',data.assigned)
                    }
                })
        },
        showOrderDetail(uuid){
            let app=this
            app.review_model = true;
            app.axios.order.getOrderDetail(uuid,
                function (response) {
                    app.orderDetail = response.data.data.item
                })
        },
        itemDetail (uuid) {
            this.$router.push({name: 'order_detail', params: { uuid: uuid }})
        },
        updateSort: function (field) {
            for (let i in this.dataTable.fields) {
                if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
                    return
                }
            }
            if (this.dataTable.sort.field != field) {
                this.dataTable.sort = {
                    field: field,
                    type: 'asc'
                }
            } else {
                if (this.dataTable.sort.type == 'asc') {
                    this.dataTable.sort = {
                        field: field,
                        type: 'desc'
                    }
                } else {
                    this.dataTable.sort = {
                        field: field,
                        type: 'asc'
                    }
                }
            }

            this.refreshData()
        },
        /**
         * Refesh data
         */
        refreshData: function () {
            if (cancel != null) {
                cancel()
            }
            let search = "";

            if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
                search = "&"+ this.filter.field + "=" + this.filter.key.trim()
            }

            if (this.filter.status != '') {
                search = search + '&status=' + this.filter.status
            }
            if (this.filter.order_type != '') {
                search = search + '&order_type=' + this.filter.order_type
            }

            let params = '?limit=' + this.dataTable.perPage + '&page=' + this.dataTable.currentPage + '&sort_by=' + this.dataTable.sort.field + '&order_by=' + this.dataTable.sort.type + search

            this.axios.order.getOrderList(params, {
                    cancelToken: new CancelToken(function executor(c) {
                        cancel = c
                    })
                },
                function (response) {
                    let langs = Object.keys(vm.$i18n.messages)
                    for (let l in langs) {
                        vm.statuses[langs[l]] = [
                            {text: vm.$t('order-phil.error', langs[l]), value: 4}
                        ]
                        vm.dataTable.items = response.data.data.items
                        vm.dataTable.total = response.data.data.pagination.total
                    }
                },
                function (error) {
                    console.log("error:"+error)
                });
        }
    },
    created: function () {
        this.debouncedInput = _.debounce(this.refreshData, 240)
        vm = this
        let CancelToken = vm.axios.CancelToken
        this.dataTable.source = CancelToken.source()

        for (let i in this.dataTable.fields) {
            if (this.dataTable.fields[i].filter != null && this.dataTable.fields[i].filter == true && this.checkShowByConfig(this.dataTable.fields[i].name)) {
                this.filter.options.push(this.dataTable.fields[i])
            }
            if (this.dataTable.fields[i].sort != null && this.dataTable.fields[i].sort == true && this.dataTable.sort.field == null) {
                this.dataTable.sort = {
                    field: 'created_at',
                    type: 'desc'
                }
            }
        }

        let langs = Object.keys(vm.$i18n.messages)
        for (let l in langs) {
            vm.order_types[langs[l]] = [
                {text: vm.$t('common.all', langs[l]), value: ''},
                {text: vm.$t('common.delivery', langs[l]), value: 'D'},
                {text: vm.$t('common.takeaway', langs[l]), value: 'C'}
            ]
        }
        let filter = this.$session.get('filter', null)
        if (filter != null && this.$route.query && this.$route.query.rollback) {
            for (let i in filter.filter) {
                this.filter[i] = filter.filter[i]
            }
            for (let i in filter.dataTable) {
                this.dataTable[i] = filter.dataTable[i]
            }
        }
        vm.refreshData()
    },
    beforeDestroy: function () {
        this.$session.set('filter', {
            filter: this.filter,
            dataTable: {
                sort: {
                    field: this.dataTable.sort.field,
                    type: this.dataTable.sort.type
                },
                currentPage: this.dataTable.currentPage,
                perPage: this.dataTable.perPage
            }
        })
    },
    watch: {
        'filter.key': function (val) {
            this.debouncedInput()
        },
        'dataTable.currentPage': function (val) {
            this.refreshData()
        },
        'dataTable.perPage': function (val) {
            this.refreshData()
        },
        'filter.status': function (val) {
            this.refreshData()
        },
        'filter.code': function (val) {
            this.refreshData()
        },
        'filter.order_type': function (val) {
            this.refreshData()
        }
    },
    computed : {
        date_locale : function () {
            let format = this.format_date_range_locale()
            if(this.$refs.drange){
                this.$refs.drange.locale = format
            }
            return format
        },
        ranges : function () {
            return this.format_date_ranges()
        },
        formatPrice: function() {
          return function(value) {
            return Number.parseFloat(value).toFixed(2).replace(/(\.0+|0+)$/, '')
          }
        }
    }
}
</script>
<style scoped>

  strong {
    font-weight: 600;
  }
</style>
<style>
  .order-details {
    width: 100%;
  }
  .order-details .item-row {
    line-height: 25px;
    width: 100%;
    clear: both;
  }
  .order-details .item-name {
    width: 70%;
    font-weight: 600;
    float: left;
  }
  .order-details .option-name {
    padding-left: 10px;
    width: 70%;
    float: left;
  }
  .order-details .topping-name {
    padding-left: 10px;
    width: 70%;
    float: left;
  }
  .order-details .item-price {
    width: 30%;
    float: left;
    text-align: right;
  }
  .order-menu-list div.order-menu-list{
    margin-top: 30px;
  }

  .order-menu-list div.row{
    margin-top: 10px;
  }
  .btn-action-view{min-width: 131px;}
  .btn-edit-cancel{min-width: 82px;}
  .view-modal-lg table.table-borderless > tbody > tr > td,
  .view-modal-lg table.table-borderless > tbody > tr > th,
  .view-modal-lg table.table-borderless > tfoot > tr > td,
  .view-modal-lg table.table-borderless > tfoot > tr > th,
  .view-modal-lg table.table-borderless > thead > tr > td,
  .view-modal-lg table.table-borderless > thead > tr > th {
    border: none;
    line-height: 40px;
    border-bottom: 1px #d1d4d7 solid;
    padding: 0px;
  }
  .btn-note {border-radius: 5px;}
  .modal .modal-huge {
    max-width: 1200px;
    width: 1200px;
  }

</style>



// WEBPACK FOOTER //
// src/views/admin/Home.vue